const Banner = '/assets/santamaria/general/santa-maria-banner.webp';
const HeaderLogo = '/assets/santamaria/general/Logo-Santa Maria.svg';
const FooterLogo = '/assets/santamaria/general/';
const BookingInActive = '/assets/santamaria/general/Icon-Buy-Ticket-Inactive.svg';
const BookingActive = '/assets/santamaria/general/Icon-Buy-Ticket-Active.svg';
const CancelInActive = '/assets/santamaria/general/Icon-Cancel-Ticket-Inactive.svg';
const CancelActive = '/assets/santamaria/general/Icon-Cancel-Ticket-Active.svg';
	//TODO Replace these two icons
const ChangeTicketInActive = '/assets/santamaria/general/Icon-Change-Ticket-Inactive.svg';
const ChangeTicketActive = '/assets/santamaria/general/Icon-Change-Ticket-Active.svg';

const Whatsapp = '/assets/santamaria/icons/whatsapp.svg';
const Email = '/assets/santamaria/icons/Icon-Mail.svg';
const HeadPhone = '/assets/santamaria/icons/headphone.svg';
const YellowLine = '/assets/santamaria/icons/yellow-line.svg';

const OriginIcon = '/assets/santamaria/icons/origin.svg';
const DestinationIcon = '/assets/santamaria/icons/destiny.svg';
const pin = '/assets/santamaria/icons/destination-new.svg';
const CalendarIcon = '/assets/santamaria/icons/calendar.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';

const pnr = '/assets/santamaria/general/find-my-pnr.svg';

const PopupIcon = '/assets/santamaria/general/Pop-up.jpg';

// Icons Section
const ist = '/assets/santamaria/icons/seats.svg';
const second = '/assets/santamaria/icons/security.svg';
const third = '/assets/santamaria/icons/ticket-icon.svg';
const close = '/assets/santamaria/icons/close.svg';

const success = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-CheckMark-Orange.svg';
const failure = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Information-Orange.svg';

const tick = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tick-Orange.svg';
const heartOn = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOn-Orange.svg';
const heartOff = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOff-Orange.svg';
const downArrow = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RightDocument-Orange.svg';
const userIcon = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Login-Orange.svg';
const trips = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyTrips-Orange.svg';
const cards = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyCards-Orange.svg';
const wallet = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const transaction = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ShareMoney-Orange.svg';
const otp = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RestorePassword-Orange.svg';

const paso_1 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const paso_2 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargePoints-Orange.svg';
const paso_3 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ID-Orange.svg';
const paso_4 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tickets-Orange.svg';
const operatorPay = '/assets/santamaria/SMPaypng.png'


const santamariaIcons = [

  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: paso_1, name: 'paso_1' },
  { icon: paso_2, name: 'paso_2' },
  { icon: paso_3, name: 'paso_3' },
  { icon: paso_4, name: 'paso_4' },
  
  { icon: Banner, name: 'Banner' },

  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: HeaderLogo, name: 'headerLogo' },
  { icon: FooterLogo, name: 'footerLogo' },

  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: pin, name: 'pin' },
  { icon: CalendarIcon, name: 'Calendar' },

  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },
		//TODO Replace these two icons
		{ icon: ChangeTicketInActive, name: 'CTIA' },
  { icon: ChangeTicketActive, name: 'CTA' },

  { icon: PopupIcon, name: 'Popup' },

  { icon: Whatsapp, name: 'Whatsapp' },
  { icon: Email, name: 'Email' },
  { icon: HeadPhone, name: 'Headphone' },
  { icon: YellowLine, name: 'Line' },

  { icon: animation, name: 'animation' },
  { icon: checkboxIcon, name: 'Checkbox' },

  // Icons Section
  { icon: ist, name: 'ist' },
  { icon: second, name: 'second' },
  { icon: third, name: 'third' },
  { icon: pnr, name: 'pnr' },
  { icon: close, name: 'close' },

  { icon: operatorPay, name: 'operatorPay' },

];

export default santamariaIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/santamariaIcons.js